import { useMediaQuery } from "@certn/cascadia-react/hooks/useMediaQuery";
import { breakpoints } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";

export function useCardStyles() {
  const isMobile = useMediaQuery(
    `(max-width: ${breakpoints["breakpoint-sm"].maxWidth.toString()}px)`
  );

  return {
    card: css({
      padding: "var(--space-6)",
      position: "relative",
      display: "grid",
      gap: "var(--space-1)",
      marginBottom: "var(--space-4)",
    }),
    statusDecline: css({
      marginBottom: "var(--space-3)",
      zIndex: 10,
      display: "flex",
    }),
    expirationBar: css({
      display: "flex",
      alignItems: "center",
      padding: `var(--space-2) var(--space-6)`,
      margin: `calc(var(--space-6) * -1)`,
      marginBottom: "var(--space-6)",
    }),
    actionBar: css({
      marginTop: "var(--space-5)",
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: "space-between",
      alignItems: "center",
      borderRadius: "var(--space-2)",
      padding: "var(--space-3)",
      zIndex: 1,
      position: "relative",
    }),
    actionBarText: css(
      {
        display: "flex",
        alignItems: "center",
      },
      isMobile && {
        marginBottom: "var(--space-1-5)",
      }
    ),
    buttonContainer: css({
      width: isMobile ? "100%" : 180,
    }),
    background: css({
      height: 260,
      width: 329,
      borderRadius: "50%",
      filter: "blur(120px)",
      position: "absolute",
      top: "-60%",
      right: "-20%",
      zIndex: 0,
      opacity: 0.2,
    }),
    circles: css({
      width: 312,
      height: 312,
      position: "absolute",
      right: "-30%",
      top: "50%",
      transform: "translate(0%, -50%)",
    }),
    circle: css({
      borderRadius: "50%",
      border: "0.5px solid rgba(10, 38, 32, 0.2)",
      display: "inline-block",
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      filter: "blur(1.5px)",
    }),
    c1: css({
      height: 125,
      width: 125,
    }),
    c2: css({
      height: 172,
      width: 172,
    }),
    c3: css({
      height: 215,
      width: 215,
    }),
    c4: css({
      height: 273,
      width: 275,
    }),
    c5: css({
      height: 312,
      width: 312,
    }),
    c6: css({
      height: 352,
      width: 352,
    }),
  };
}
